// Shareable IC Memo links: proxy.proximityparks.com/<deal-name>-ic-memo
//
// The deal's title (the Name: line, else its first address) is slugged. Two
// deals can share a title, so a link carries ?id=<first 8 of the uuid> only
// when the slug alone would be ambiguous, and ?v=<n> to pin a UW version
// (no ?v = the deal's current version).

import { parseDealName } from "./parseDealName";

export function slugify(s) {
  return String(s || "")
    .toLowerCase()
    .normalize("NFKD").replace(/[̀-ͯ]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function dealTitle(deal) {
  return parseDealName(deal?.sourceNotes) || deal?.dealName || deal?.addresses?.[0] || "deal";
}

export function memoPath(deal, deals = [], versionNumber = null) {
  const slug = slugify(dealTitle(deal));
  const params = new URLSearchParams();
  if (deals.filter((d) => slugify(dealTitle(d)) === slug).length > 1) params.set("id", String(deal.id).slice(0, 8));
  if (versionNumber != null) params.set("v", String(versionNumber));
  const q = params.toString();
  return `/${slug}-ic-memo${q ? `?${q}` : ""}`;
}

// -> { slug, id, v } when the URL is a memo link, else null.
export function parseMemoPath(pathname, search = "") {
  const m = /^\/(.+)-ic-memo\/?$/i.exec(pathname || "");
  if (!m) return null;
  const p = new URLSearchParams(search);
  const v = p.get("v");
  return { slug: decodeURIComponent(m[1]).toLowerCase(), id: p.get("id"), v: v && /^\d+$/.test(v) ? Number(v) : null };
}

export function findMemoDeal(route, deals = []) {
  if (!route) return null;
  const hits = deals.filter((d) => slugify(dealTitle(d)) === route.slug && (!route.id || String(d.id).startsWith(route.id)));
  if (hits.length) return hits[0];
  return route.id ? deals.find((d) => String(d.id).startsWith(route.id)) || null : null;
}
